import 'bootstrap';
import 'select2';

window.bootstrap = require('bootstrap');

$(document).ready(function () {
    let $body = $("body");

    let tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
    let tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
        return new bootstrap.Tooltip(tooltipTriggerEl)
    })

    let report = {
        updates: () => {
            let $buttons = $(".cbc-report__update-button");

            $buttons.each(function () {
                let $button = $(this);
                let $targetArea = $button.closest(".cbc-report").find(".cbc-report__update-details-target");

                $button.on("click", function () {
                    let $template = $button.find("template").clone();
                    $targetArea.empty();
                    $targetArea.append($template.prop('content'));
                })
            })
        },
        sev: () => {
            let $buttons = $(".cbc-report__sev-button");

            $buttons.each(function () {
                let $button = $(this);
                let $targetArea = $button.closest(".cbc-report").find(".cbc-report__sev-details-target");

                $button.on("click", function () {
                    let $template = $button.find("template").clone();
                    $targetArea.empty();
                    $targetArea.append($template.prop('content'));
                })
            })
        },
        lines: () => {
            let $stopsdirs = $(".cbc-report__stops-dir");

            $stopsdirs.each(function () {
                let $stopsdir = $(this);

                let index = 0;
                let $stops = $stopsdir.find(".cbc-report__stop");

                let isStopActive = ($stop) => {
                    if ($stop.is("[data-impacted=1]") || $stop.is("[data-first=1]") || $stop.is("[data-last=1]")) {
                        return true;
                    }
                };

                $stops.each(function () {
                    let $stop = $(this);

                    let $prevStop = $stops.eq(index - 1);
                    let $nextStop = $stops.eq(index + 1);
                    let $overNextStop = $stops.eq(index + 2);

                    if (isStopActive($stop)) {
                        // currently active
                    } else if (
                        isStopActive($nextStop) || isStopActive($prevStop)
                    ) {
                        // inactive but next to active
                        if (!isStopActive($nextStop) && !$stop.is("[data-last=1]") && !$overNextStop.is("[data-last=1]")) {
                            $stop.after("<div class='cbc-report__stop-spacer'>&nbsp;</div>")
                        }
                    } else {
                        $stop.hide();
                    }

                    index++;
                })
            });
        },
        accordion: () => {
            let $buttons = $("button.cbc-report-title");
            $buttons.on("click", function () {
                let $thisButton = $(this);

                // don't scroll if already open
                // inverted because BS triggers first
                if ($thisButton.attr("aria-expanded") === "false") {
                    return;
                }

                let $targetElement = $thisButton.closest(".cbc-report__accordion").find(".cbc-report");

                let elOffset = $targetElement.offset().top;
                let windowHeight = $(window).height();
                let offset = elOffset - (windowHeight / 3);

                let speed = ($(document).scrollTop() - offset) / 2;
                let timeout = 800;

                setTimeout(() => {
                    $('html, body').animate({scrollTop: offset}, speed);
                }, timeout)
            })
        },
        filters: () => {
            let $filters = $("select.cbc-filter");

            $filters.on("change", function () {
                $(this).closest("form").submit();
            })
        }
    }

    if ($(".cbc-filter").length) {
        report.filters();
    }

    if ($(".cbc-report__lines").length) {
        report.lines();
    }

    if ($(".cbc-report__update-button").length) {
        report.updates();
    }

    if ($(".cbc-report__sev-button").length) {
        report.sev();
    }

    if ($("button.cbc-report-title").length) {
        report.accordion();
    }
});